/* Theme css - ModernHaus-SoHo */


import { StyleSheet } from 'react-native';



export const theme = {
  PRIMARY_FONT: {
    fontFamily: 'BebasNeue-Regular',
    fontWeight: 400,
  },
  SECONDARY_FONT: {
    fontFamily: 'Delegate-Regular',
    fontWeight: 400,
  },
  TERTIARY_FONT: {
    fontFamily: "NYCTypewriter-Mono",
    letterSpacing: 1.35,
    fontWeight: 400,
  },
  
  FONT_XSMALL: {
    fontSize: 10,
  },
  FONT_SMALL: {
    fontSize: 12,
    lineHeight: 16,
  },
  FONT_MEDIUM: {
    fontSize: 16,
    lineHeight: 24,
    letterSpacing: 0.12
  },
  FONT_LARGE: {
    fontSize: 34,
    lineHeight: 34,

  },
  FONT_XLARGE: {
    fontSize: 34,
    lineHeight: 34,
  },
  FONT_XXLARGE: {
    fontSize: 34,
    lineHeight: 34,
  },

  COLORS: {
    WHITE: "#ffffff",
    BLACK: "#000000",

    BACKGROUND_COLOR: '#FFFBF0', // background color for main containers
    BACKGROUND_COLOR_CONTRAST: '#241F20',

    BACKGROUND_COLOR_SECONDARY: "#737F6F", // secondary background color (eg: footer)
    BACKGROUND_COLOR_SECONDARY_CONTRAST: "#F8F8F8",

    PRIMARY_COLOR: "#FFFBF0", // primary color
    PRIMARY_TEXT_COLOR: "#241F20", // primary text color

    SECONDARY_COLOR: "#241F20", // secondary color
    SECONDARY_TEXT_COLOR: "#FFFBF0", // secondary text color

    ACCENT_COLOR: "#676527",
    ACCENT_Text_COLOR: "#FFFBF0"
  },
};


export default StyleSheet.create({


  welcomeScreenPrimaryBtn: {
    backgroundColor: theme.COLORS.BACKGROUND_COLOR_SECONDARY,
  },
  welcomeScreenPrimaryBtnTxt: {
    color: theme.COLORS.BACKGROUND_COLOR_SECONDARY_CONTRAST,
  },

  primaryBtn: {
    borderRadius: 4,
  },
  primaryBtnTxt: {
    fontSize: 14,
    lineHeight: 16
  },
  secondaryBtn: {
    borderRadius: 4
  },
  secondaryBtnTxt: {
    fontSize: 14,
    lineHeight: 16
  },
  tertiaryBtn: {
    borderRadius: 4,
  },
  tertiaryBtnTxt: {
    fontSize: 14,
    lineHeight: 16
  },

  input: {
    borderRadius: 4,
  },

  Dropdown: {
    borderRadius: 4,
  },
  dropdown_web: {
    borderRadius: 4,
  },

  mainContainerHeaderContainer: {
    display: "none"
  },

  headerContainer: {
      backgroundColor: "#241F20",
  },
  headerContainerLogo: {
    height: 18,
    width: 175
  },
  headerContainerWithBack: {
    backgroundColor: "#241F20",
  },

  backText: {
    color: theme.COLORS.WHITE,
  },
  backIcon: {
    filter: "invert(1)",
    tintColor: theme.COLORS.WHITE,
  },

  notificationIcon: {
    filter: "invert(1)",
    tintColor: theme.COLORS.WHITE,
  },

  tabContainerTopBorder: {
    borderTopColor: theme.COLORS.WHITE,
  },
  
  smallIconMultipleWidgetContainer: {
    paddingVertical: 32,
    borderBottomColor: theme.COLORS.BLACK,
    borderBottomWidth: 0.5,
  },
  smallIconMultipleWidgetTitleContainer: {
    display: "flex",
    marginBottom: 16,
  },
  smallIconMultipleWidget_WidgetsContainer: {
    height: "auto",
    borderWidth: 0,
    paddingHorizontal: 0,
    paddingVertical: 0
  },
  smallIconMultipleWidget_WidgetsImg: {
    height: "auto",
    width: "100%",
    aspectRatio: 390 / 118,
    maxHeight: 350
  },

  smallIconMultipleWidget_WidgetsImg_full_width_large: {
    aspectRatio: 390 / 194,
    maxHeight: 350
  },
  

  multipleLargeWidgetTitleContainer: {
    display: "none"
  },
  multipleLargeWidget_WidgetsContainer: {
    width: 260
  },


  bannerWidgetMultipleMainContainer: {
    paddingVertical: 32,
    backgroundColor: "#D3CEC7"
  },


  infoWidgetsWidgetContainer: {
    paddingVertical: 32,
    borderBottomColor: theme.COLORS.BLACK,
    borderBottomWidth: 1,
  },
  infoWidgetsWidgetContainer_landscape: {
    paddingVertical: 32,
    borderBottomColor: theme.COLORS.BLACK,
    borderBottomWidth: 1,
  },


  infoWidgetButtonContainer: {
    backgroundColor: theme.COLORS.ACCENT_COLOR,
    borderRadius: 4,
    borderColor: undefined
  },
  infoWidgetButtonContainerText: {
    fontSize: 14,
    lineHeight: 16,
    textTransform: "uppercase",
    color: theme.COLORS.ACCENT_Text_COLOR,
  },

  infoWidgetButtonContainer_landscape: {
    backgroundColor: theme.COLORS.ACCENT_COLOR,
    borderRadius: 4,
     borderColor: undefined
  },
  infoWidgetButtonContainerText_landscape: {
    fontSize: 14,
    lineHeight: 16,
    textTransform: "uppercase",
    color: theme.COLORS.ACCENT_Text_COLOR,
  },


  infoWidgetsWidgetContainer_first_widget: {
    backgroundColor: theme.COLORS.ACCENT_COLOR,
  },
  infoWidgetHeaderTitle_first_widget: {
    color: theme.COLORS.ACCENT_Text_COLOR,
  },
  infoWidgetHeaderSubtitle_first_widget: {
    color: theme.COLORS.ACCENT_Text_COLOR,
    paddingHorizontal: 0,
    padding: 0,
    ...theme.FONT_SMALL
  },

  infoWidgetsWidgetContainer_landscape_first_widget: {
    backgroundColor: theme.COLORS.ACCENT_COLOR,
  },
  infoWidgetHeaderTitle_landscape_first_widget: {
    color: theme.COLORS.ACCENT_Text_COLOR,
    ...theme.FONT_XXLARGE
  },
  infoWidgetHeaderSubtitle_landscape_first_widget: {
    color: theme.COLORS.ACCENT_Text_COLOR,
    paddingHorizontal: 0,
    padding: 0,
  },


  infoWidgetHeaderSubtitle_percy_all_description: {
    textAlign: "none",
    ...theme.TERTIARY_FONT,
    paddingHorizontal: 0,
  },
  infoWidgetHeaderSubtitle_landscape_percy_all_description: {
    ...theme.TERTIARY_FONT,
    paddingHorizontal: 0,
  },



  guestDetailsWidgetContainer: {
    paddingVertical: 32,
    borderBottomColor: theme.COLORS.BLACK,
    borderBottomWidth: 1,
  },

  guestDetailsDateItemTitle: {
    ...theme.TERTIARY_FONT,
    ...theme.FONT_XSMALL,
    color: "#737F6F"
  },
  guestDetailsDateItemSubTitle: {
    ...theme.FONT_SMALL,
  }


});
